function getTimestamp(awsDate) {
  return Date.parse(awsDate.replace(/(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z/g, '$1-$2-$3T$4:$5:$6Z'));
}
export const dateUtil = {
  clockOffset: 0,
  setClockOffsetByErrorMsg(error) {
    const datetimes = error.match(/\d+T\d+Z/g);
    if ((datetimes === null || datetimes === void 0 ? void 0 : datetimes.length) !== 3) {
      return;
    }
    const signingDate = getTimestamp(datetimes === null || datetimes === void 0 ? void 0 : datetimes[0]);
    const serverDate = getTimestamp(datetimes === null || datetimes === void 0 ? void 0 : datetimes[2]);
    // Signature expired: 20211028T222511Z is now earlier than 20211028T235817Z (20211029T000317Z - 5 min.)
    this.clockOffset = serverDate - signingDate;
  },
  isClockSkewError(error) {
    return /Signature ([expired | not yet current]).*/g.test(error);
  },
  getDateWithClockOffset() {
    if (this.clockOffset) {
      return new Date(new Date().getTime() + this.clockOffset);
    }
    return new Date();
  },
  resetClockOffset() {
    this.clockOffset = 0;
  }
};
export const convertToUrlSearchString = (obj, withQuestionMark = false) => {
  const keysWhichHasValue = Object.keys(obj).filter(k => !!obj[k]);
  return keysWhichHasValue.reduce((acc, cur, index) => `${acc + cur}=${encodeURIComponent(obj[cur])}${index === keysWhichHasValue.length - 1 ? '' : '&'}`, withQuestionMark ? '?' : '');
};